import { DialogActions, styled } from "@mui/material";

export const ModalFooter = styled(DialogActions)`
  justify-content: center;
  padding: ${(props) => props.theme.spacing(2)};

  ${(props) => props.theme.breakpoints.down("sm")} {
    padding: ${(props) => props.theme.spacing(4)};
    padding-bottom: ${(props) => props.theme.spacing(2)};
  }
`;
